import React from 'react';
import PropTypes from "prop-types";

import { Input } from 'semantic-ui-react';

import CommonErrorIcon from 'components/common/CommonErrorIcon';

import './PlainInput.scss';

function PlainInput(props) {
  const {
    value,
    onChange,
    disabled,
    placeholder,
    errors,
  } = props;

  return (
    <div className={`plain-input__component${errors ? ' errors' : ''}`}>
      {/* Input */}
      <Input
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
      />

      {/* Error Icon */}
      {errors &&
        <div className="error-icon">
          <CommonErrorIcon errorText={errors} />
        </div>
      }
    </div>
  );
}

PlainInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  errors: PropTypes.string,
};

PlainInput.defaultProps = {
  value: null,
  disabled: null,
  placeholder: null,
  errors: null,
};

export default PlainInput;
